/* eslint-disable indent */
import styled from 'styled-components';
import { Button } from 'antd';
import variableStyles from '../../constants/variables-styles';

const StyledButton = styled(Button)`
  width: 100%;
  &.custom-ant-button {
    font-size: ${(props) => (props.size === 'small' ? '12px' : '14px')};
    font-weight: 600;
    padding: 0 12px;
    box-shadow: none;
    border-radius: 99px;
    height: ${(props) => {
      switch (props.size) {
        case 'large':
          return '52px';
        case 'medium':
          return '44px';
        case 'small':
          return '32px';
        default:
          return '52px';
      }
    }};
    color: ${(props) => {
      switch (props.type) {
        case 'primary':
          return variableStyles.backgroundBasic;
        case 'outline':
          return variableStyles.primaryBasic;
        default:
          return 'transparent';
      }
    }};
    background: ${(props) => {
      switch (props.type) {
        case 'primary':
          return variableStyles.primaryBasic;
        case 'outline':
          return variableStyles.backgroundBasic;
        default:
          return 'transparent';
      }
    }};
    border-color: ${(props) => {
      switch (props.type) {
        case 'primary':
          return 'transparent';
        case 'outline':
          return variableStyles.primaryBasic;
        default:
          return 'transparent';
      }
    }};

    &:hover {
      color: ${(props) => {
        switch (props.type) {
          case 'primary':
            return variableStyles.backgroundBasic;
          case 'outline':
            return variableStyles.primaryBasic6;
          default:
            return 'transparent';
        }
      }};
      border-color: ${(props) => {
        switch (props.type) {
          case 'primary':
            return 'transparent';
          case 'outline':
            return variableStyles.primaryBasic;
          default:
            return 'transparent';
        }
      }};
      background: ${(props) => {
        switch (props.type) {
          case 'primary':
            return variableStyles.primaryBasic8;
          case 'outline':
            return variableStyles.backgroundBasic;
          default:
            return 'transparent';
        }
      }};
    }
    &:focus {
      color: ${(props) => {
        switch (props.type) {
          case 'primary':
            return variableStyles.backgroundBasic;
          case 'outline':
            return variableStyles.primaryBasic;
          default:
            return 'transparent';
        }
      }};
      background: ${(props) => {
        switch (props.type) {
          case 'primary':
            return variableStyles.primaryBasic;
          case 'outline':
            return variableStyles.backgroundBasic;
          default:
            return 'transparent';
        }
      }};
      border-color: ${(props) => {
        switch (props.type) {
          case 'primary':
            return 'transparent';
          case 'outline':
            return variableStyles.primaryBasic;
          default:
            return 'transparent';
        }
      }};
    }
    &:disabled {
      cursor: not-allowed !important;
      color: ${(props) => {
        switch (props.type) {
          case 'primary':
            return variableStyles.primaryBasic6;
          case 'outline':
            return variableStyles.primaryBasic6;
          default:
            return variableStyles.primaryBasic6;
        }
      }};
      background: ${(props) => {
        switch (props.type) {
          case 'primary':
            return variableStyles.primaryBasic1;
          case 'outline':
            return variableStyles.primaryBasic1;
          default:
            return variableStyles.primaryBasic1;
        }
      }};
      border-color: ${(props) => {
        switch (props.type) {
          case 'primary':
            return 'transparent';
          case 'outline':
            return variableStyles.primaryBasic6;
          default:
            return 'transparent';
        }
      }};
    }
  }
`;

export default StyledButton;
